import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
declare var $: any;
declare var jQuery: any;
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { CompanyMasterService } from '../../../services/companymaster.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

export interface MeetingDocumentListItem {
  key: string;
  index: number;
  title: string;
  docId: string;
  fileType: string;
  isPdf: boolean;
  minuteType: 'DRAFT' | 'FINAL' | null;
  uploadDate?: any;
}

@Component({
  selector: 'app-meetingdocument',
  templateUrl: './meetingdocument.component.html',
  styleUrls: ['./meetingdocument.component.css'],
  providers: [MeetingMasterService, CompanyMasterService]
})
export class MeetingdocumentComponent implements OnInit {

  @Input('documentObject') documentObject: any;
  @Input('meetingObject') meetingObject: any;
  @Output() emitFileURL = new EventEmitter();

  notRegularMeeting: boolean = true;

  isDodumentObjectEmpty: boolean;
  atrDocument: any;
  isNoticeFileAvailable: boolean = false;
  noticeFileName: any;
  noticeFileType: any;
  agendaFileType: any;
  draftFileType: any;
  finalFiletype: any;
  ATRFileType: any;
  noticeDate: any;
  noticeTime: any;
  isAgendaFileAvailable: boolean = false;
  agendaFileName: any;
  agendaDate: any;
  agendaTime: any;
  isDraftFileAvailable: boolean = false;
  draftFileName: any;
  draftDate: any;
  draftTime: any;
  isFinalFileAvailable: boolean = false;
  finalFileName: any;
  finalDate: any;
  finalTime: any;
  isATRFileAvailable: boolean = false;
  ATRFileName: any;
  regularDocumentList: any;
  iframeURL: any
  count : number = null;
  val1 : number = null;
  val2 : number = null;
  val3 : number = null;
  val4 : number = null;
  val5 : number = null;
  /** Board / Director / KMP can vote on minutes in dashboard (matches agenda eligibility patterns). */
  canVoteMinutes = false;
  viewMode: 'grid' | 'list' = 'list';
  documentItems: MeetingDocumentListItem[] = [];

  constructor(private companyMasterService: CompanyMasterService, private meetingMasterService: MeetingMasterService, private sanitizer: DomSanitizer) { }

  /** PSS Documents.* usually expose docId; some API shapes use alternate ID keys. */
  resolveDocumentFileId(file: any, hint: 'notice' | 'agenda' | 'draft' | 'final' | 'atr' = 'agenda'): string {
    const normalize = (v: any): string => {
      if (v === null || v === undefined) {
        return '';
      }
      const s = String(v).trim();
      if (!s || s === 'undefined' || s === 'null') {
        return '';
      }
      return s;
    };

    if (typeof file === 'string') {
      return normalize(file);
    }
    if (!file || typeof file !== 'object') {
      return '';
    }

    const direct = normalize(
      file.docId ??
      file.docID ??
      file.documentId ??
      file.DocumentID ??
      file.DocumentId ??
      file.documentID ??
      file._id ??
      file.id ??
      file.DocumentManagementID ??
      file.documentManagementID
    );
    if (direct) {
      return direct;
    }

    // Fallback: infer from known shape when file node has only name/flags.
    const docRoot = this.documentObject || {};
    const atr0 = this.meetingObject?.AtrDocument?.[0] || {};
    const fallback =
      hint === 'draft'
        ? normalize(docRoot?.draftFile?.docId ?? docRoot?.draftFile?._id ?? atr0?.DraftDocumentID ?? atr0?.DraftMinutesDocumentID ?? atr0?.MinutesDocumentID)
        : hint === 'final'
          ? normalize(docRoot?.finalFile?.docId ?? docRoot?.finalFile?._id ?? atr0?.FinalDocumentID ?? atr0?.FinalMinutesDocumentID ?? atr0?.MinutesDocumentID)
          : hint === 'notice'
            ? normalize(docRoot?.noticeFile?.docId ?? docRoot?.noticeFile?._id ?? atr0?.NoticeDocumentID)
            : hint === 'atr'
              ? normalize(docRoot?.ATRFile?.docId ?? docRoot?.ATRFile?._id ?? atr0?.ATRDocumentID)
              : normalize(docRoot?.agendaFile?.docId ?? docRoot?.agendaFile?._id ?? atr0?.AgendaDocumentID);
    if (fallback) {
      return fallback;
    }

    const targetName = normalize((file as any)?.name).toLowerCase();
    if (targetName) {
      const seen = new Set<any>();
      const walk = (node: any): string => {
        if (!node || typeof node !== 'object' || seen.has(node)) {
          return '';
        }
        seen.add(node);
        if (Array.isArray(node)) {
          for (const item of node) {
            const got = walk(item);
            if (got) {
              return got;
            }
          }
          return '';
        }
        const nodeName = normalize(node.name ?? node.originalFileName).toLowerCase();
        if (nodeName && nodeName === targetName) {
          const nid = normalize(
            node.docId ??
            node.docID ??
            node.documentId ??
            node.DocumentID ??
            node.DocumentId ??
            node._id
          );
          if (nid) {
            return nid;
          }
        }
        for (const k of Object.keys(node)) {
          const got = walk(node[k]);
          if (got) {
            return got;
          }
        }
        return '';
      };
      const deep = walk(docRoot);
      if (deep) {
        return deep;
      }
    }
    return '';
  }

  fileExtFromName(name: string): string {
    if (!name || typeof name !== 'string') {
      return '';
    }
    const i = name.lastIndexOf('.');
    return i >= 0 ? name.slice(i + 1).toLowerCase() : '';
  }

  isPdfExt(ext: string): boolean {
    return (ext || '').toLowerCase() === 'pdf';
  }

  get resolvedNoticeDocId(): string {
    return this.resolveDocumentFileId(this.documentObject?.noticeFile, 'notice');
  }

  get resolvedDraftDocId(): string {
    return this.resolveDocumentFileId(this.documentObject?.draftFile, 'draft');
  }

  get resolvedFinalDocId(): string {
    return this.resolveDocumentFileId(this.documentObject?.finalFile, 'final');
  }

  get resolvedAtrDocId(): string {
    return this.resolveDocumentFileId(this.documentObject?.ATRFile, 'atr');
  }

  get resolvedAgendaFileDocId(): string {
    return this.resolveDocumentFileId(this.documentObject?.agendaFile, 'agenda');
  }
  ngOnInit() {
    if (!this.documentObject || typeof this.documentObject !== 'object') {
      this.isDodumentObjectEmpty = true;
      this.documentItems = [];
      this.count = 0;
      this.refreshMinuteVotePermission();
      return;
    }

    if(this.documentObject.noticeFile?.isAvaible){
       this.val1 = 1;       
    }

    if(this.documentObject.agendaFile?.isAvaible){
      this.val2 = 1;
    }

    if(this.documentObject.draftFile?.isAvaible){
      this.val3 = 1;
    }

    if(this.documentObject.finalFile?.isAvaible){
      this.val4 = 1;
    }

    if(this.documentObject.ATRFile?.isAvaible){
      this.val5 = 1;
    }

    // this.count = this.val5 + this.val4 + this.val3 + this.val2 + this.val1+this.documentObject.agendaFileArray.length;   
    this.count = (this.documentObject.agendaFileArray || []).length;   
    if((this.documentObject.agendaFileArray || []).length > 0){
      this.isAgendaFileAvailable=true;
    }
  
    
    var self = this;
    //console.log("meeting Object DOcument", this.meetingObject, this.documentObject);

    // //console.log("documentObject",this.documentObject);

    if (this.meetingObject.meetingType) {
      this.notRegularMeeting = false;
      this.regularDocumentList = this.documentObject;

      if (_.size(this.documentObject)) {
        self.isDodumentObjectEmpty = false;
      }
      else {
        self.isDodumentObjectEmpty = true;
      }

    } else {
      this.notRegularMeeting = true;

      this.atrDocument = this.meetingObject?.AtrDocument?.[0];
      //this.atrDocument = this.meetingObject.Documents[0];
      //console.log("atrDocument",this.regularDocumentList);

      if (_.size(this.documentObject)) {
        self.isDodumentObjectEmpty = false;

        if (_.size(this.atrDocument)) {

          if (_.size(this.atrDocument.noticeDate)) {
            let date = this.atrDocument.noticeDate;
            date = date.split('-')
            date = date[1]+'-'+date[0]+'-'+date[2]
            this.noticeDate = date;
            this.noticeTime = this.atrDocument.noticeTime;
          } else {
            this.noticeDate = "";
            this.noticeTime = "";
          }

          if (_.size(this.atrDocument.agendaDate)) {
            let date = this.atrDocument.agendaDate;
            date = date.split('-')
            date = date[1]+'-'+date[0]+'-'+date[2]
            this.agendaDate = date
            this.agendaTime = this.atrDocument.agendaTime;
          } else {
            this.agendaDate = "";
            this.agendaTime = "";
          }

          if (_.size(this.atrDocument.draftDate)) {
            let date = this.atrDocument.draftDate
            date = date.split('-')
            date = date[1]+'-'+date[0]+'-'+date[2]
            this.draftDate = date;
            this.draftTime = this.atrDocument.draftTime;
          } else {
            this.draftDate = "";
            this.draftTime = "";
          }

          if (_.size(this.atrDocument.finalDate)) {
            let date = this.atrDocument.finalDate;
            date = date.split('-')
            date = date[1]+'-'+date[0]+'-'+date[2]
            this.finalDate = date
            this.finalTime = this.atrDocument.finalTime;
          } else {
            this.finalDate = "";
            this.finalTime = "";
          }

        } else {
          this.noticeDate = "";
          this.noticeTime = "";
          this.agendaDate = "";
          this.agendaTime = "";
          this.draftDate = "";
          this.draftTime = "";
          this.finalDate = "";
          this.finalTime = "";
        }

        if (_.size(this.documentObject.noticeFile)) {
          if (this.documentObject.noticeFile.isAvaible) {
            this.isNoticeFileAvailable = true;
            this.noticeFileName = this.documentObject.noticeFile.name
            this.noticeFileType = this.fileExtFromName(this.noticeFileName)
          }
          else {
            this.noticeFileName = "-";
            this.isNoticeFileAvailable = false;
          }

        } else {
          this.noticeFileName = "-";
        }

        if (_.size(this.documentObject.agendaFile)) {
          if (this.documentObject.agendaFile.isAvaible) {
            // this.isAgendaFileAvailable = true;
            this.agendaFileName = this.documentObject.agendaFile.name
            this.agendaFileType = this.fileExtFromName(this.agendaFileName)

          }
          else {
            // this.isAgendaFileAvailable = false;
            this.agendaFileName = "-";
          }

        } else {
          this.agendaFileName = "-";
        }

        if (_.size(this.documentObject.draftFile)) {
          if (this.documentObject.draftFile.isAvaible) {
            this.isDraftFileAvailable = true;
            this.draftFileName = this.documentObject.draftFile.name
            this.draftFileType = this.fileExtFromName(this.draftFileName)


          }
          else {
            this.isDraftFileAvailable = false;
            this.draftFileName = "-";
          }

        } else {
          this.draftFileName = "-";
        }

        if (_.size(this.documentObject.finalFile)) {
          if (this.documentObject.finalFile.isAvaible) {
            this.isFinalFileAvailable = true;
            this.finalFileName = this.documentObject.finalFile.name

            this.finalFiletype = this.fileExtFromName(this.finalFileName)


          }
          else {
            this.isFinalFileAvailable = false;
            this.finalFileName = "-";
          }

        } else {
          this.finalFileName = "-";
        }

        if (_.size(this.documentObject.ATRFile)) {
          if (this.documentObject.ATRFile.isAvaible) {
            this.isATRFileAvailable = true;
            this.ATRFileName = this.documentObject.ATRFile.name;
            this.ATRFileType = this.fileExtFromName(this.ATRFileName)

          } else {
            this.isATRFileAvailable = false;
            this.ATRFileName = "-";
          }
        } else {
          this.ATRFileName = "-";
        }

      } else {
        self.isDodumentObjectEmpty = true;
      }

    }

    this.refreshMinuteVotePermission();
    this.buildDocumentItems();
  }

  refreshMinuteVotePermission(): void {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user') || '{}');
      const t = `${userInfo?.TypeOfUser ?? userInfo?.userType ?? ''}`.trim();
      const tl = t.toLowerCase().replace(/\s+/g, '');
      this.canVoteMinutes =
        t === 'BoardMember' ||
        t === 'Board Member' ||
        t === 'KMP' ||
        t === 'Director' ||
        tl === 'boardmember' ||
        tl === 'kmp' ||
        tl === 'director';
    } catch {
      this.canVoteMinutes = false;
    }
  }

  get meetingIdForVote(): string {
    return (this.meetingObject && (this.meetingObject._id || this.meetingObject.meetingId)) || '';
  }

   goBack() {
   this.ngOnInit()
  }
showAgenda(){
  this.isDodumentObjectEmpty=true;
}

  setViewMode(mode: 'grid' | 'list') {
    this.viewMode = mode;
  }

  buildDocumentItems() {
    const items: MeetingDocumentListItem[] = [];
    let index = 1;

    const pushItem = (
      key: string,
      title: string,
      docId: string,
      fileType: string,
      minuteType: 'DRAFT' | 'FINAL' | null = null,
      uploadDate: any = null
    ) => {
      const fid = docId ? String(docId).trim() : '';
      if (!fid || fid === 'undefined' || fid === 'null') {
        return;
      }
      const ft = fileType != null ? String(fileType) : '';
      items.push({
        key,
        index: index++,
        title,
        docId: fid,
        fileType: ft,
        isPdf: this.isPdfExt(ft),
        minuteType,
        uploadDate
      });
    };

    if (this.isNoticeFileAvailable) {
      pushItem('notice', 'NOTICE', this.resolvedNoticeDocId, this.noticeFileType);
    }
    if (this.isDraftFileAvailable) {
      pushItem('draft', 'Draft Minutes', this.resolvedDraftDocId, this.draftFileType, 'DRAFT');
    }
    if (this.isFinalFileAvailable) {
      pushItem('final', 'Final Minutes', this.resolvedFinalDocId, this.finalFiletype, 'FINAL');
    }
    if (this.isATRFileAvailable) {
      pushItem('atr', 'ATR', this.resolvedAtrDocId, this.ATRFileType);
    }

    const extras = (this.documentObject && this.documentObject.agendaFileArray) || [];
    extras.forEach((agenda: any, i: number) => {
      const name = agenda?.name || `Document ${i + 1}`;
      pushItem(
        `extra-${i}`,
        name,
        this.resolveDocumentFileId(agenda),
        this.fileExtFromName(name),
        null,
        agenda?.UploadDate
      );
    });

    this.documentItems = items;
    this.count = items.length;
  }

  openDocumentItem(item: MeetingDocumentListItem) {
    if (!item) {
      return;
    }
    if (!item.isPdf) {
      this.meetingMasterService.getAttendanceFile(item.docId);
      return;
    }
    this.openDocumentPdf(item);
  }

  async openDocumentPdf(item: MeetingDocumentListItem) {
    const fileMeta: any = await this.getFileUrlPlain(item.docId);
    if (!fileMeta?.url) {
      return;
    }
    // Show viewer pane first so Adobe embeds into a visible container (same timing pattern as agenda)
    this.showDocumentPdfDetail();
    this.emitFileURL.emit({
      FinalUrl: fileMeta.url,
      filename: fileMeta.filename || item.title,
      title: item.title,
      minuteType: item.minuteType || null,
      canVoteMinutes: this.canVoteMinutes
    });
  }

  getFileUrlPlain = async (fileID: string) => {
    const response = await this.meetingMasterService.getAttendanceFileName(fileID);
    const url = environment.PSSFileurl + '/Document_Type/' + response.data.Filename + '#toolbar=0';
    let filename = 'File';
    try {
      filename = response.data.Filename.split('-')[1] || 'File';
    } catch (ex) {
      filename = 'File';
    }
    return { url, filename };
  }

  showDocumentPdfDetail() {
    const setDisplay = (elId: string, visible: boolean) => {
      const el = document.getElementById(elId);
      if (el) {
        el.style.display = visible ? 'block' : 'none';
      }
    };
    setDisplay('documentDetails', true);
    setDisplay('Document', false);
    setDisplay('Agenda', false);
    setDisplay('Attendance', false);
    setDisplay('individual-meeting', false);
    setDisplay('agendaAnalytics', false);
    setDisplay('agendaDetails', false);
  }

  downloadDocumentFile(fileID, fileType) {
    const fid =
      fileID !== null && fileID !== undefined ? String(fileID).trim() : '';
    if (!fid || fid === 'undefined' || fid === 'null') {
      console.warn('MeetingdocumentComponent: missing document id for download');
      return;
    }

    const ft = fileType != null && fileType !== undefined ? String(fileType) : '';
    if (this.isPdfExt(ft)) {
      const item: MeetingDocumentListItem = {
        key: 'legacy',
        index: 0,
        title: 'Document',
        docId: fid,
        fileType: ft,
        isPdf: true,
        minuteType: null
      };
      this.openDocumentPdf(item);
    } else {
      this.meetingMasterService.getAttendanceFile(fid);
    }
  }

  downloadRegularDocumentFile(filepath, filename) {

    var gemURL = ""
    this.companyMasterService.getGEMUrl().then(responseCompany => {
      //console.log("response GEM URL", responseCompany);
      if (responseCompany.status == 0) {
        var companyDetails = responseCompany.companyData;
        //console.log("response GEM URL companyDetails", companyDetails);
        if (_.size(companyDetails)) {
          gemURL = companyDetails[0].GEMAccessURL ? companyDetails[0].GEMAccessURL : "";
          //console.log("gemURL",gemURL);

          this.meetingMasterService.getRegularFile(filepath, this.meetingObject.meetingId, filename, gemURL).then(response => {

          })

        }
      }
    })

    // this.meetingMasterService.getRegularFile(filepath, this.meetingObject.meetingId,filename).then(response => {



    var gemURL = ""
    this.companyMasterService.getGEMUrl().then(responseCompany => {
      //console.log("response GEM URL", responseCompany);
      if (responseCompany.status == 0) {
        var companyDetails = responseCompany.companyData;
        if (_.size(companyDetails)) {
          gemURL = companyDetails.GEMAccessURL ? companyDetails.GEMAccessURL : ""
          if (_.size(gemURL)) {

            this.meetingMasterService.getRegularFile(filepath, this.meetingObject.meetingId, filename, gemURL).then(response => {

              // //console.log("response", response.size);

              // var byteArray = new Uint8Array(response.size)
              // //console.log("byteArray", byteArray);

              // var downloadUrl = URL.createObjectURL(response);

              // //console.log("downloadUrl", downloadUrl);

              // var link = document.createElement('a');
              // document.body.appendChild(link);
              // link.href = downloadUrl;
              // link.download = filename;
              // link.click();

            })

          }
        }
      }
    })





    // var link = document.createElement('a');
    // document.body.appendChild(link);
    // link.href = downloadUrl;
    // link.download = filename;
    // link.click();

    // })
    
  }

  showDocumentDetails(){
      document.getElementById('documentDetails').style.display = "block";
     document.getElementById('Document').style.display = "none";
    //  document.getElementById('Agenda').style.display = "none";
    //  document.getElementById('Attendance').style.display = "none";
    //   document.getElementById('individual-meeting').style.display = "none";
    //    document.getElementById('agendaAnalytics').style.display = "none";
  }
 
  


}
